import AWS from 'aws-sdk'
import Compressor from 'compressorjs'
import { v3 as uuidv3 } from 'uuid'

import {
  NAMESPACE_URL,
  ARTISTS_ARTWORKS_BUCKET,
  ARTISTS_COMPRESSED_ARTWORKS_BUCKET,
  ARTISTS_AVATAR_BUCKET,
  ACCESS_KEY_ID,
  SECRET_ACCESS_KEY,
  AMAZON_S3_REGION,
  ARTISTS_RESUME_BUCKET,
  ARTISTS_TAX_BUCKET
} from '../config'

AWS.config.update({
  accessKeyId: ACCESS_KEY_ID,
  secretAccessKey: SECRET_ACCESS_KEY,
  region: AMAZON_S3_REGION
})

const S3 = new AWS.S3()

export const uploadImage = (email, file, onSuccess, onError, onProgress) => {
  new Compressor(file, {
    quality: 0.6,
    convertSize: 1,
    success(result) {
      const key = generateKey(email, file.name)
      const compressObjParams = {
        Bucket: ARTISTS_COMPRESSED_ARTWORKS_BUCKET,
        Key: key,
        Body: result,
        ContentType: result.type
      }
      const objParams = {
        Bucket: ARTISTS_ARTWORKS_BUCKET,
        Key: key,
        Body: file,
        ContentType: file.type
      }
      const compressObjPercent = result.size / (result.size + file.size)
      const ObjPercent = 1 - compressObjPercent

      S3.putObject(compressObjParams)
        .on('httpUploadProgress', function ({ loaded, total }) {
          onProgress({
            percent: (loaded / total) * 100 * compressObjPercent
          })
        })
        .send(function (err, data) {
          if (err) {
            onError(err)
          } else {
            S3.putObject(objParams)
              .on('httpUploadProgress', function ({ loaded, total }) {
                onProgress({
                  percent: (compressObjPercent + (loaded / total) * ObjPercent) * 100
                })
              })
              .send(function (err, data) {
                if (err) {
                  onError(err)
                } else {
                  onSuccess({
                    s3_url: generateUrl(ARTISTS_ARTWORKS_BUCKET, AMAZON_S3_REGION, key),
                    static_url: generateUrl(ARTISTS_COMPRESSED_ARTWORKS_BUCKET, AMAZON_S3_REGION, key)
                  })
                }
              })
          }
        })
    },
    error(err) {
      onError(err)
    }
  })
}

export const uploadAvatar = (email, file, onSuccess, onError, onProgress) => {
  const key = generateAvatarKey(email, file.name)
  const objParams = {
    Bucket: ARTISTS_AVATAR_BUCKET,
    Key: key,
    Body: file,
    ContentType: file.type
  }
  S3.putObject(objParams)
    .on('httpUploadProgress', function ({ loaded, total }) {
      onProgress({
        percent: (loaded / total) * 100
      })
    })
    .send(function (err, data) {
      if (err) {
        onError(err)
      } else {
        onSuccess({
          url: generateUrl(ARTISTS_AVATAR_BUCKET, AMAZON_S3_REGION, key)
        })
      }
    })
}

export const uploadResume = (email, file, onSuccess, onError, onProgress) => {
  const key = generateKey(email, file.name)
  const objParams = {
    Bucket: ARTISTS_RESUME_BUCKET,
    Key: key,
    Body: file,
    ContentType: file.type
  }
  S3.on('httpUploadProgress', function ({ loaded, total }) {
    onProgress({
      percent: Math.round((loaded / total) * 100)
    })
  })
    .putObject(objParams)
    .send(function (err, data) {
      if (err) {
        onError(err)
      } else {
        onSuccess({
          url: generateUrl(ARTISTS_RESUME_BUCKET, AMAZON_S3_REGION, key)
        })
      }
    })
}

export const uploadTaxPaper = (email, file, onSuccess, onError, onProgress) => {
  const key = generateTaxKey(email, file.name)
  const objParams = {
    Bucket: ARTISTS_TAX_BUCKET,
    Key: key,
    Body: file,
    ContentType: file.type
  }
  S3.on('httpUploadProgress', function ({ loaded, total }) {
    onProgress({
      percent: Math.round((loaded / total) * 100)
    })
  })
    .putObject(objParams)
    .send(function (err, data) {
      if (err) {
        onError(err)
      } else {
        onSuccess({
          url: generateUrl(ARTISTS_TAX_BUCKET, AMAZON_S3_REGION, key)
        })
      }
    })
}

const generateUrl = (bucket, region, key) => {
  return 'https://' + bucket + '.s3-' + region + '.amazonaws.com/' + key
}

const generateKey = (email, fileName) => {
  return (
    uuidv3(email, NAMESPACE_URL) +
    '/' +
    Math.floor(Math.random() * 10000) +
    '_' +
    fileName
      .replace(/(^\s*)|(\s*$)/g, '')
      .replace(/\(/g, '')
      .replace(/\)/g, '')
      .replace(/ /g, '_')
      .replace(/#/g, '2304')
  )
}

const generateAvatarKey = (email, fileName) => {
  return (
    uuidv3(email, NAMESPACE_URL) +
    '/avatar' +
    '/' +
    Math.floor(Math.random() * 10000) +
    '_' +
    fileName
      .replace(/(^\s*)|(\s*$)/g, '')
      .replace(/\(/g, '')
      .replace(/\)/g, '')
      .replace(/ /g, '_')
      .replace(/#/g, '2304')
  )
}

const generateTaxKey = (email, fileName) => {
  return (
    uuidv3(email, NAMESPACE_URL) +
    '/tax' +
    '/' +
    Math.floor(Math.random() * 10000) +
    '_' +
    fileName
      .replace(/(^\s*)|(\s*$)/g, '')
      .replace(/\(/g, '')
      .replace(/\)/g, '')
      .replace(/ /g, '_')
      .replace(/#/g, '2304')
  )
}
